import { useState } from "react";
import {
  AggregateScoreFilter,
  AggregateScoreOrderField,
  GetAggregateScoresQueryResult,
  OrderDirection,
  useGetAggregateScoresQuery,
} from "~/operations";
import { AggregateScoresEdges } from "~/components/FirewatchPage";

export const useFetchAggregateScoresRecursively = ({
  scopeMrn,
  filter,
  skip,
}: {
  filter: AggregateScoreFilter;
  scopeMrn: string;
  skip: boolean;
}) => {
  const [allItems, setAllItems] = useState<AggregateScoresEdges>([]);
  const pageSize = 100;

  const { fetchMore, networkStatus } = useGetAggregateScoresQuery({
    variables: {
      first: 100,
      entityMrn: scopeMrn || "",
      orderBy: {
        field: AggregateScoreOrderField.Rank,
        direction: OrderDirection.Asc,
      },
      filter,
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: (data: GetAggregateScoresQueryResult["data"]) =>
      handleNewData(data),
    skip: !scopeMrn || skip,
  });

  const handleNewData = async (data: GetAggregateScoresQueryResult["data"]) => {
    if (
      !data ||
      data.aggregateScores?.__typename !== "AggregateScoresConnection"
    )
      return;

    const newEdges = data.aggregateScores.edges;
    const hasNextPage = data.aggregateScores.pageInfo.hasNextPage;

    setAllItems((prev) => [...(prev ?? []), ...(newEdges ?? [])]);

    if (!hasNextPage) {
      return;
    } else {
      const after = data.aggregateScores.pageInfo.endCursor;

      await fetchMore({
        variables: {
          first: pageSize,
          after,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;
          return fetchMoreResult;
        },
      });
    }
  };

  return { allItems, networkStatus };
};
